import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import BannerItem from './components/BannerItem';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/navigation';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';

function Banners({ banners = [] }) {
  return (
    <div className="lg:h-[424px] h-screen">
      <Swiper
        spaceBetween={0}
        slidesPerView={1}
        className="homepage-slider"
        navigation
        pagination
        modules={[Navigation, Pagination]}
      >
        {banners?.map((banner) => (
          <SwiperSlide key={banner.id}>
            <BannerItem banner={banner} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Banners;
